import {
    createUnorderedHorizontalList,
    UnorderedHorizontalList,
} from '@vfde-brix/ws10/unordered-horizontal-list';
import { StateProps } from 'Container/App/interface';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { startAppListening } from 'Container/App/listener';
import { selectActiveSubscriptionId } from 'Container/App/slice';
import { selectCurrentOfferData } from 'Container/App/selectors';
import { HORIZONTAL_LIST_CONTAINER } from 'Container/App/constants';

/**
 * Mount horizontal list
 */
export const mountHorizontalList = (): UnorderedHorizontalList | null => {
    const horizontalList = createComponentById(createUnorderedHorizontalList, HORIZONTAL_LIST_CONTAINER, NO_PATTERN_BUSINESS_LOGIC);

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCurrentOfferData(currentState) !== selectCurrentOfferData(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const activeSubscriptionId = selectActiveSubscriptionId(api.getState());

            horizontalList && updateHorizontalList(horizontalList, activeSubscriptionId);
        },
    });

    return horizontalList;
};

/**
 * Update horizontal list
 */
const updateHorizontalList = (element: UnorderedHorizontalList, activeSubscriptionId: StateProps['activeSubscriptionId']) => {
    const { items } = element.getProperties();

    for (const item of items) {
        if (item.link?.optLinkTarget === '_blank') {
            item.link.stdLinkUrl = window[ADDITIONAL_PAGE_OPTIONS].pibs[activeSubscriptionId!];
        }
    }

    element.update({ items });
};
